<template>
    <div class="payment-gateway-page-wrapper">
        <grid
            :is-auto-height="true"
            :rowData="rowData"
            grid-theme="ag-theme-alpine-compact"
            :columnDefs="columnDefs"
            :isSearch="false"
        ></grid>
    </div>
</template>

<script>
import api from '../../../api';
import { PAYMENT_GATEWAY_DATA_ENDPOINT } from '../../../endpoints';
import { formatResponseError } from '../../../utils/api';
import grid from '../../generic/grid/grid.vue';
export default {
    components: { grid },
    data() {
        return {
            rowData: [],
        };
    },
    computed: {
        columnDefs() {
            return [
                {
                    field: 'modified',
                    headerName: 'Timestamp',
                    type: 'dateTimeColumn',
                    minWidth: 190,
                },
                {
                    field: 'action',
                    headerName: 'Action',
                    autoHeight: true,
                    wrapText: true,
                    minWidth: 250,
                },
            ];
        },
    },
    mounted() {
        this.fetchLogs();
    },
    methods: {
        async fetchLogs() {
            try {
                this.$parent.$emit('busy', true);

                const { data } = await api.get(`${PAYMENT_GATEWAY_DATA_ENDPOINT()}logs/`);
                this.rowData = data;
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not fetch logs' });
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
</style>